import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {
  STATEMENT_FREQUENCY,
  STATEMENT_DETAIL_LTR,
  LOGIC_BLOCK_SORT,
  SUB_TOTALS,
  PRINT_DB_REFERENCE,
  SUM_INT_DIFFERENTLY,
  SEPARATE_CHECKS,
} from '../../../../constants/Lookup';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';

const initialValues = {
  statementStandardData: {},
  dropDownData: {},
  statementStandardStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'statementStandard',
  initialState: {...initialValues},
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchStatementStandardData: (state, action) => {
      state.statementStandardData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postStatementStandardData: (state, action) => {
      state.statementStandardStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetStatementStandard: (state) => {
      state.standardStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchDropDownData,
  fetchStatementStandardData,
  postStatementStandardData,
  fetchError,
  resetMsg,
  resetStatementStandard,
} = slice.actions;

export const fetchDropDown = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [
          STATEMENT_FREQUENCY,
          STATEMENT_DETAIL_LTR,
          LOGIC_BLOCK_SORT,
          SUB_TOTALS,
          PRINT_DB_REFERENCE,
          SUM_INT_DIFFERENTLY,
          SEPARATE_CHECKS,
        ],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchStatementStandard = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/statements/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchStatementStandardData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postStatementStandard = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/statements`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postStatementStandardData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatementStandard());
  };
};
